import React from 'react'
import PropTypes from 'prop-types'
import { bem } from '@argos/utils'

const cn = bem({ prefix: 'lc-', block: 'message' })

export function Message(WrappedComponent) {
  return class extends React.Component {
    static propTypes = {
      name: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      type: PropTypes.oneOf([
        'user',
        'agent',
        'system',
        'join',
        'leave',
        'newPushPageUrl',
        'imageTransfer',
        'fileTransfer',
      ]).isRequired,
      status: PropTypes.string.isRequired,
      fileType: PropTypes.string,
    }

    render() {
      const { status, type } = this.props

      return (
        <li
          data-animation-status={status}
          className={cn('', type)}
          data-test={cn('', type)}
          ref={(ref) => {
            this.message = ref
          }}>
          <WrappedComponent {...this.props} className={cn} />
        </li>
      )
    }
  }
}

export default Message
